import script from "./Financial.vue?vue&type=script&lang=ts&setup=true"
export * from "./Financial.vue?vue&type=script&lang=ts&setup=true"

import "./Financial.vue?vue&type=style&index=0&id=51abb31c&scoped=true&lang=less"
import "./Financial.vue?vue&type=style&index=1&id=51abb31c&lang=less"

import exportComponent from "D:\\work\\risfond-branchmanagementsystem\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51abb31c"]])

export default __exports__